<template>
  <section class="comp-redpacket">
    <div
      v-for="(redpacket, index) in redpackets"
      :key="index"
      data-actionid="2"
      data-itemtext="红包类组件"
      :data-itemotherinfo="`id=${redpacket.id}&status=${redpacket.status}`"
      @click="clickHandle(redpacket, index)"
    >
      <img width="100%" :src="picHost + getRedpacketImg(redpacket)" />
      <!-- 活动裂变-老客展示 -->
      <div class="redpacketText" v-if="isActiveFission && redpacket.shareRedPacket && $root.isOldUser" :style="`background-image: url('${baseUrl}static/imgs/textBack.png')`">
        <p>邀请1位新用户成单后，即可使用</p>
        <!-- 老客+未领取 -->
        <p v-if="redpacket.status === 1" class="noHave">已有<span class="bold">{{redpacket.fissionCount||0}}</span>位新用户领券，还差<span class="bold">1</span>人下单即可得券</p>
      </div>
      <!-- 分享者+新客展示 -->
      <div class="redpacketText" v-if="isActiveFission && redpacket.shareRedPacket && !$root.isOldUser && !isSharedPeople && getIsUserLogin()" :style="`background-image: url('${baseUrl}static/imgs/textBack.png')`">
        <p>邀请1位用户浏览后，即可使用</p>
      </div>
    </div>

    <!-- 立即领取弹层 -->
    <div class="cover" v-if="compProps.dialog && compProps.dialog.showRedDialog" @touchmove.prevent.stop></div>
    <div v-show="this.compProps.dialog.hasRedPackModel" :class="$root.channel == '1' ? 'redpack-dialog pc-dialog' : 'redpack-dialog'" v-if="compProps.dialog && compProps.dialog.showRedDialog" :style="`background-image: url('${picHost}${compProps.dialog.bgImg}')`">
      <div class="redpacket-wrap">
        <div class="redpacket-item" v-for="(item, index) in compProps.recivedRepackList" :key="index">
          <div class="price" :class="{'font20': item.amountConsumeLimit > 999, 'fontPc': (item.amountConsumeLimit > 999) && $root.channel == '1'}"><sub>¥</sub>{{item.amountConsumeLimit}}</div>
          <div class="title">{{item.redPacketTitle}}</div>
          <div class="instruction">{{item.useinstruction}}</div>
          <div class="instruction effective-time">{{item.effectiveInfo}}</div>
        </div>
      </div>
      <img class="close" :src="`${baseUrl}static/imgs/redpacketCloseIcon.png`" @click="closeRecivedDialog"/>
      <img :class="$root.channel === '1' ? 'toUseBtnPc' : 'toUseBtn'" :src="`${picHost}${compProps.dialog.redPackModelUseImg}`" @click="toUseRedpacket(true)"/>
    </div>
    <!-- 立即使用弹层 -->
    <div class="cover" v-if="compProps.dialog && compProps.dialog.showRedDialog" @touchmove.prevent.stop @click="closeRecivedDialog"></div>
    <div v-show="this.compProps.dialog.hasDialog"
      :class="$root.channel == '1' ? 'receiveRed-dialog pc-dialog' : 'receiveRed-dialog'"
      v-if="compProps.dialog && compProps.dialog.showRedDialog"
      :style="`background-image: url('${picHost}${compProps.dialog.bgImg}')`"
      @click="toUseRedpacket(false)"></div>

    <!-- TOC-4599-Q小红书页面加授权弹窗 -->
    <div v-if="compProps.dialog && compProps.dialog.showQActivityDialog" class="cover" @touchmove.prevent.stop>
      <div class="q-activity-dialog">
        <p>确认领取活动优惠券？</p>
        <p>领取前请确认<strong @click="openQActivityRules">《活动规则》</strong></p>
        <div class="q-activity-btn-wrap">
          <div class="cancel-btn" @click="closeQActivityDialog">
            <p>取消</p>
          </div>
          <div class="confirm-btn" @click="receiveQActivityDialog">
            <p>领取</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
/**
 * 红包的ui组件
*/
import tujialogin from '@/utils/tujialogin.js'
import tjCookie from '@/utils/tjCookie'
import { Sniff } from '@/utils/q_sniff'
import {
  REDPACKET_TYPE_ENUM,
  REPORT_IMAGE_MAP
} from '@/views/promotion/serviceComps/config/redPackConfig'
export default {
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      type: 0,
      redpackets: [],
      checkedRedpacket: null,
      autoGetRedpacketId: this.$route.query.autoGetRedpacketId,
      fId: Number(this.$route.query.fId)
    }
  },
  watch: {
    /* 这里有可能需要加deep: true */
    compProps: {
      handler(newVal) {
        /* 需要根据各种红包情况计算出需要展示的图片 */
        if (newVal) {
          const isPointsType = this.getIsPointsType(newVal?.items)
          if (isPointsType) {
            this.handlePointsType(newVal)
            return
          }
          this.redpackets = newVal.items.map((item) => {
            // alert(JSON.stringify(item))
            let status = 0 // 0 未开始，1 进行中，2 已结束，3 已领取，4 已抢光 5 已使用
            if (item.activityType === 3) {
              this.type = 1 // 0 普通，1秒杀
            }
            if (item.activityStatus === 4) {
              status = 4
            } else if (item.activityStatus === 3) {
              status = 2
            } else if (item.activityStatus === 2 && item.receive === false) {
              status = 1
            }
            if (item.receive) {
              status = 3
            }
            if (item.receive && item.used) { // 领过券，已使用
              if (item.imgLink && item.imgLink[4]) {
                status = 5
              }
            }
            return {
              ...item,
              status: status
            }
          })
        }
      },
      deep: true
    }
  },
  computed: {
    isActiveFission() {
      return ['T20230310142815', 'T20230310191107', 'Q20230310140905'].indexOf(this.$route.query.id) > -1
    },
    isSharedPeople() { // 被分享者
      if (process.env.VUE_APP_LOCAL !== 'Q') {
        if (this.fId && this.fId !== Number(tjCookie.getUserId())) {
          return true
        } else {
          return false
        }
      } else {
        if (Sniff.uinfo && this.fId && this.fId !== Sniff.uinfo.uid) {
          return true
        } else {
          return false
        }
      }
    }
  },
  mixins: [tujialogin],
  methods: {
    getRedpacketImg(redpacket) {
      switch (Number(redpacket.channelType)) {
      case REDPACKET_TYPE_ENUM.POINTS:
        return this.getPointsImg(redpacket)
      default:
        return redpacket.imgLink[this.getRedpacketStatus(redpacket.status)]
      }
    },
    getPointsImg(redpacket) {
      return redpacket.imgLink[REPORT_IMAGE_MAP[redpacket.status || 0]]
    },
    // 判断是否是积分类型
    getIsPointsType(items) {
      return items?.every(
        (item) => Number(item.channelType) === REDPACKET_TYPE_ENUM.POINTS
      )
    },
    // 处理积分类型
    handlePointsType(newVal) {
      this.redpackets = newVal?.items || []
    },
    async getIsUserLogin() {
      if (process.env.VUE_APP_LOCAL !== 'Q' && (await this.isLogin())) {
        return true
      } else if (process.env.VUE_APP_LOCAL === 'Q' && Sniff.isLogin) {
        return true
      } else {
        return false
      }
    },
    /**
     * 使用红包
     * @param {int} id 红包id
     */
    toUseRedpacket(flag) {
      if (!this.checkedRedpacket) {
        this.checkedRedpacket = this.redpackets.find((item) => {
          return item.id === this.autoGetRedpacketId
        })
      }
      this.$emit('closeRecivedDialog', this.checkedRedpacket)
      this.$emit('useRedpacket', this.checkedRedpacket, flag)
    },
    // toUseReceiveRedpacket() {
    //   if (!this.checkedRedpacket) {
    //     this.checkedRedpacket = this.redpackets.find((item) => {
    //       return item.id === this.autoGetRedpacketId
    //     })
    //   }
    //   this.$emit('closeRecivedDialog', this.checkedRedpacket)
    //   this.$emit('useRedpacket', this.checkedRedpacket, false)
    // },
    closeRecivedDialog() {
      this.$emit('closeRecivedDialog', this.checkedRedpacket)
    },
    clickHandle(info, index) {
      this.checkedRedpacket = info
      info.redPackIndex = index
      console.log('红包类组件', info)
      this.$emit('action', info)
    },
    // closeRecivedRedDialog() {
    //   this.$emit('closeRecivedDialog', this.checkedRedpacket)
    // },
    getRedpacketStatus(status) { // 这里是很垃圾的实现，主要是我偷懒了。不同的红包类型代表不同的业务。业务是不应该耦合的。
      // status：0 未开始，1 进行中，2 已结束，3 已领取，4 已抢光 5 已使用
      // 对应img-List中索引：0-未领取，1-立即使用，2-已抢光，3-几点开抢，4-已使用
      if (this.type === 0) {
        switch (status) { // 普通红包
        case 3:
          return 1
        case 4:
        case 2:
          return 2
        case 5:
          return 4
        default:
          return 0
        }
      } else if (this.type === 1) { // 新红包目前没秒杀概念
        switch (status) { // 秒杀红包
        case 3:
          return 1
        case 4:
          return 2
        case 2:
          return 2
        case 1:
          return 0
        default:
          return 3
        }
      }
    },
    openQActivityRules() {
      this.$emit('openWebView', { url: 'https://m.flight.qunar.com/shark/active/ceb3d8a9cc3b87d3649d74317018fda5' })
    },
    closeQActivityDialog() {
      this.$emit('closeQActivityDialog')
    },
    receiveQActivityDialog() {
      this.$emit('receiveQActivityDialog')
    }
  }
}
</script>
<style lang="scss" scoped>
@function size($n) {
  @return $n/375 * 100vw;
}
.redpacketText {
  display: flex;
  flex-direction: column;
  background-size: 100% 100%;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #814800;
  letter-spacing: 0.02px;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
  p {
    margin: 2px 0;
  }
  .noHave {
    font-family: PingFangSC-Semibold;
    font-size: 12px;
    color: #814800;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    .bold {
      display: inline-block;
      margin: 0 4px;
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #FF6509;
    }
  }
}
.comp-redpacket {
  width: 100%;
  display: flex;
  > div {
    width: 100%;
    font-size: 0;
  }
  .receiveRed-dialog {
    position: fixed;
    width: 290px;
    height: 298px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    background-size: cover;
    border-radius: 20px;
    padding: 0px 20px 55px;
    box-sizing: content-box;
  }
  .redpack-dialog {
    position: fixed;
    width: 238px;
    height: 249px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    background-size: cover;
    border-radius: 20px;
    padding: 62px 20px 87px;
    box-sizing: content-box;
    .redpacket-wrap {
      height: 249px;
      background-color: transparent;
      overflow-y: auto;
      .redpacket-item {
        box-sizing: content-box;
        margin-bottom: 5px;
        background-color: #fff;
        height: 32px;
        padding: 12px 18px 10px 95px;
        color: #ff6666;
        font-family: PingFangSC-Light;
        border-radius: 12px;
        position: relative;
        .price {
          font-family: PingFangSC-Medium;
          position: absolute;
          font-size: 38px;
          font-weight: 500;
          left: 0;
          top: 0;
          width: 95px;
          text-align: center;
          height: 54px;
          line-height: 54px;
          sub{
            font-size: 14px;
          }

        }
        .font20 {
          font-size: 28px;
        }
        .title {
          font-family: PingFangSC-Medium;
          font-size: 12px;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          height: 12px;
          line-height: 12px;
          transform: translateY(-1px);
        }
        .instruction {
          font-size: 12px;
          font-weight: 400;
          transform: scale(0.75) translateY(-1px);
          transform-origin: left center;
          white-space: nowrap;
          overflow: hidden;
          height: 12px;
          line-height: 12px;
          width: 175px;
          text-overflow: ellipsis;
        }
        .effective-time {
          color: #999;
          transform-origin: left top;
        }
      }
    }
    .close {
      position: absolute;
      top: -36px;
      right: 0;
      width: 25px;
      height: 25px;
    }
    .toUseBtn {
      position: absolute;
      bottom: 40px;
      left: 50%;
      margin: 0 auto;
      width: 160px;
      height: 30px;
      transform: translateX(-50%);
    }
    .toUseBtnPc {
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      margin: 0 auto;
      height: 40px;
    }
  }
  .pc-dialog {
    height: 450px;
    width: 400px;
    padding: 0;
    background-size: cover;
    box-sizing: border-box;
    .redpacket-wrap {
      height: 290px;
      margin: 60px 20px 0;
      .redpacket-item {
        height: 80px;
        padding: 18px 0 0 140px;
        box-sizing: border-box;
        .price {
          top: 0;
          left: 0;
          width: 140px;
          height: 80px;
          line-height: 80px;
          text-align: center;
          sub {
            font-size: 22px;
          }
        }
        .fontPc {
          font-size: 40px;
        }
        .title {
          font-size: 16px;
          height: 18px;
          line-height: 18px;
          width: 180px;
          padding-right: 10px;
        }
        .instruction {
          font-size: 14px;
          height: 16px;
          line-height: 16px;
          width: auto;
        }
        .effective-time {
          font-size: 14px;
          height: 16px;
          line-height: 16px;
          width: auto;
        }
      }
    }
  }
   .cover {
      width: 100vw;
      height: 100vh;
      background-color: rgba(0,0,0,.4);
      position: fixed;
      left: 0;
      top: 0;
      z-index: 5;
    }

    .q-activity-dialog {
      width: size((300));
      height: size(158);
      border-radius: size(8);
      background-color: #fff;
      margin-top: 50vh;
      margin-left: 50vw;
      transform: translate(-50%,-50%);

      p:nth-child(1) {
        padding-top: size(24);
        color: #333;
        font-family: PingFangSC-Medium;
        font-size: size(18);
        font-weight: 500;
        letter-spacing: 0;
        text-align: center;
      }

      p:nth-child(2) {
        color: #333;
        font-size: size(14);
        line-height: size(20);
        padding: size(18);
        text-align: center;

        strong {
          color: #03cde9;
        }
      }

      .q-activity-btn-wrap {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0 size(16);

        .cancel-btn {
          background: #fff;
          border: size(1) solid #03cde9;
          color: #03cde9;
          border-radius: size(20);
          width: size(118);
          height: size(40);
          display: flex;
          justify-content: center;
          align-items: center;

          p {
            font-family: PingFangSC-Medium;
            font-size: size(16);
            font-weight: 500;
            color: #03cde9;
            padding-top: 0;
          }
        }

        .confirm-btn {
          width: size(118);
          height: size(40);
          background: #03cde9;
          color: #fff;
          font-size: size(16);
          border-radius: size(20);
          display: flex;
          justify-content: center;
          align-items: center;

          p {
            font-family: PingFangSC-Medium;
            font-size: size(16);
            font-weight: 500;
            color: #fff;
            padding-top: 0;
          }
        }

      }
    }

}
</style>
